module.exports = __webpack_public_path__ + "img/energetic-driver.dd25ba95.svg";